import { render } from "./MonthlyTargetBlock.vue?vue&type=template&id=139c33cc"
import script from "./MonthlyTargetBlock.vue?vue&type=script&lang=js"
export * from "./MonthlyTargetBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__